"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
const $a5fd07fa01589658$var$GRID_SIZE = 4;
function $a5fd07fa01589658$var$copyBoard(board) {
    if (typeof structuredClone === "function") return structuredClone(board);
    return JSON.parse(JSON.stringify(board));
}
function $a5fd07fa01589658$var$createEmptyBoard() {
    return Array.from({
        length: $a5fd07fa01589658$var$GRID_SIZE
    }, ()=>Array($a5fd07fa01589658$var$GRID_SIZE).fill(0));
}
class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.initialState = initialState ? $a5fd07fa01589658$var$copyBoard(initialState) : $a5fd07fa01589658$var$createEmptyBoard();
        if (!this._loadState()) this._resetState();
    }
    _resetState() {
        this.board = $a5fd07fa01589658$var$copyBoard(this.initialState);
        this.score = 0;
        this.status = "idle";
    }
    _loadState() {
        try {
            if (typeof window !== "undefined" && window.localStorage) {
                const data = window.localStorage.getItem("2048_game_state");
                if (data) {
                    const savedState = JSON.parse(data);
                    this.board = savedState.board;
                    this.score = savedState.score;
                    this.status = savedState.status;
                    return true;
                }
            }
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Failed to load save:", error);
        }
        return false;
    }
    saveState() {
        try {
            if (typeof window !== "undefined" && window.localStorage) window.localStorage.setItem("2048_game_state", JSON.stringify({
                board: this.board,
                score: this.score,
                status: this.status
            }));
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error("Failed to save state:", error);
        }
    }
    getScore() {
        return this.score;
    }
    getState() {
        return this.board;
    }
    getStatus() {
        return this.status;
    }
    _executeMove(moveLogic) {
        if (this.status !== "playing") return false;
        const oldBoard = JSON.stringify(this.board);
        moveLogic();
        const isChanged = oldBoard !== JSON.stringify(this.board);
        if (isChanged) this.afterMove();
        return isChanged;
    }
    moveLeft() {
        return this._executeMove(()=>{
            this.board = this.board.map((row)=>this.processRow(row));
        });
    }
    moveRight() {
        return this._executeMove(()=>{
            this.board = this.board.map((row)=>{
                const reversed = [
                    ...row
                ].reverse();
                return this.processRow(reversed).reverse();
            });
        });
    }
    moveUp() {
        return this._executeMove(()=>{
            for(let i = 0; i < $a5fd07fa01589658$var$GRID_SIZE; i++){
                const column = this.board.map((row)=>row[i]);
                const processedColumn = this.processRow(column);
                for(let j = 0; j < $a5fd07fa01589658$var$GRID_SIZE; j++)this.board[j][i] = processedColumn[j];
            }
        });
    }
    moveDown() {
        return this._executeMove(()=>{
            for(let i = 0; i < $a5fd07fa01589658$var$GRID_SIZE; i++){
                const column = this.board.map((row)=>row[i]);
                const processedColumn = this.processRow([
                    ...column
                ].reverse()).reverse();
                for(let j = 0; j < $a5fd07fa01589658$var$GRID_SIZE; j++)this.board[j][i] = processedColumn[j];
            }
        });
    }
    start() {
        this.board = $a5fd07fa01589658$var$copyBoard(this.initialState);
        this.status = "playing";
        this.score = 0;
        this.addRandomTile();
        this.addRandomTile();
        this.saveState();
    }
    restart() {
        this._resetState();
        try {
            window.localStorage.removeItem("2048_game_state");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    processRow(row) {
        const numbers = row.filter((cell)=>cell !== 0);
        for(let i = 0; i < numbers.length - 1; i++)if (numbers[i].value === numbers[i + 1].value) {
            const sum = numbers[i].value * 2;
            numbers[i].value = sum;
            numbers[i].mergedId = numbers[i + 1].id;
            numbers[i + 1] = 0;
            this.score += sum;
            i++;
        }
        const result = numbers.filter((n)=>n !== 0);
        while(result.length < $a5fd07fa01589658$var$GRID_SIZE)result.push(0);
        return result;
    }
    addRandomTile() {
        const emptyCells = [];
        for(let row = 0; row < $a5fd07fa01589658$var$GRID_SIZE; row++){
            for(let col = 0; col < $a5fd07fa01589658$var$GRID_SIZE; col++)if (this.board[row][col] === 0) emptyCells.push({
                row: row,
                col: col
            });
        }
        if (emptyCells.length === 0) return;
        const randomIndex = Math.floor(Math.random() * emptyCells.length);
        const { row: targetRow, col: targetCol } = emptyCells[randomIndex];
        this.board[targetRow][targetCol] = {
            id: Math.random().toString(36).substring(2, 10),
            value: Math.random() < 0.9 ? 2 : 4
        };
    }
    afterMove() {
        this.addRandomTile();
        const win = this.board.some((row)=>row.some((cell)=>cell !== 0 && cell.value === 2048));
        if (win) this.status = "win";
        else if (this.isGameOver()) this.status = "lose";
        this.saveState();
    }
    isGameOver() {
        for(let row = 0; row < $a5fd07fa01589658$var$GRID_SIZE; row++)for(let col = 0; col < $a5fd07fa01589658$var$GRID_SIZE; col++){
            if (this.board[row][col] === 0) return false;
        }
        for(let row = 0; row < $a5fd07fa01589658$var$GRID_SIZE; row++)for(let col = 0; col < $a5fd07fa01589658$var$GRID_SIZE; col++){
            const current = this.board[row][col].value;
            if (col < $a5fd07fa01589658$var$GRID_SIZE - 1 && current === this.board[row][col + 1].value) return false;
            if (row < $a5fd07fa01589658$var$GRID_SIZE - 1 && current === this.board[row + 1][col].value) return false;
        }
        return true;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$elements = {
    score: document.querySelector(".header__score"),
    tileContainer: document.querySelector(".tile-container"),
    gameBoard: document.querySelector(".game-board"),
    startButton: document.querySelector(".header__button--start"),
    messages: [
        ...document.querySelectorAll(".message")
    ],
    winMessage: document.querySelector(".message-win"),
    loseMessage: document.querySelector(".message-lose")
};
const $09e991522ca7e64e$var$CLASSES = {
    BUTTON_START: "header__button--start",
    BUTTON_RESTART: "header__button--restart",
    TILE: "tile",
    TILE_NEW: "tile-new",
    TILE_MERGED: "tile-merged",
    HIDDEN: "hidden"
};
const $09e991522ca7e64e$var$touchStart = {
    x: 0,
    y: 0
};
function $09e991522ca7e64e$var$setTileAttributes(tile, value, col, row) {
    tile.textContent = value.value;
    tile.className = [
        $09e991522ca7e64e$var$CLASSES.TILE,
        `tile--${value.value}`,
        `tile-position-${col}-${row}`
    ].join(" ");
}
function $09e991522ca7e64e$var$handleMergedTile(value, col, row, activeIds) {
    if (!value.mergedId) return;
    const deadTile = document.getElementById(value.mergedId);
    if (deadTile) {
        deadTile.className = [
            $09e991522ca7e64e$var$CLASSES.TILE,
            `tile--${deadTile.textContent}`,
            `tile-position-${col}-${row}`
        ].join(" ");
        activeIds.push(value.mergedId);
        setTimeout(()=>deadTile.remove(), 150);
    }
    return true;
}
function $09e991522ca7e64e$var$drawGame() {
    const board = $09e991522ca7e64e$var$game.getState();
    $09e991522ca7e64e$var$elements.score.textContent = $09e991522ca7e64e$var$game.getScore();
    const activeIds = [];
    board.forEach((rowArr, row)=>{
        rowArr.forEach((value, col)=>{
            if (value === 0) return;
            activeIds.push(value.id);
            let tile = document.getElementById(value.id);
            if (!tile) {
                tile = document.createElement("div");
                tile.id = value.id;
                $09e991522ca7e64e$var$setTileAttributes(tile, value, col, row);
                $09e991522ca7e64e$var$elements.tileContainer.appendChild(tile);
                tile.classList.add($09e991522ca7e64e$var$CLASSES.TILE_NEW);
            } else $09e991522ca7e64e$var$setTileAttributes(tile, value, col, row);
            if ($09e991522ca7e64e$var$handleMergedTile(value, col, row, activeIds)) {
                tile.style.zIndex = 10;
                tile.classList.add($09e991522ca7e64e$var$CLASSES.TILE_MERGED);
                setTimeout(()=>tile.classList.remove($09e991522ca7e64e$var$CLASSES.TILE_MERGED), 200);
                delete value.mergedId;
            }
        });
    });
    $09e991522ca7e64e$var$elements.tileContainer.querySelectorAll(`.${$09e991522ca7e64e$var$CLASSES.TILE}`).forEach((tile)=>{
        if (!activeIds.includes(tile.id)) tile.remove();
    });
}
function $09e991522ca7e64e$var$showStatusMessage(status) {
    $09e991522ca7e64e$var$elements.messages.forEach((m)=>m.classList.add($09e991522ca7e64e$var$CLASSES.HIDDEN));
    if (status === "win") $09e991522ca7e64e$var$elements.winMessage.classList.remove($09e991522ca7e64e$var$CLASSES.HIDDEN);
    if (status === "lose") $09e991522ca7e64e$var$elements.loseMessage.classList.remove($09e991522ca7e64e$var$CLASSES.HIDDEN);
}
function $09e991522ca7e64e$var$updateButtonToRestart() {
    if ($09e991522ca7e64e$var$elements.startButton.classList.contains($09e991522ca7e64e$var$CLASSES.BUTTON_START)) {
        $09e991522ca7e64e$var$elements.startButton.classList.replace($09e991522ca7e64e$var$CLASSES.BUTTON_START, $09e991522ca7e64e$var$CLASSES.BUTTON_RESTART);
        $09e991522ca7e64e$var$elements.startButton.textContent = "Restart";
    }
}
$09e991522ca7e64e$var$elements.startButton.addEventListener("click", (event)=>{
    event.preventDefault();
    $09e991522ca7e64e$var$elements.messages.forEach((m)=>m.classList.add($09e991522ca7e64e$var$CLASSES.HIDDEN));
    if ($09e991522ca7e64e$var$elements.startButton.classList.contains($09e991522ca7e64e$var$CLASSES.BUTTON_START)) {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$updateButtonToRestart();
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$game.start();
    }
    $09e991522ca7e64e$var$drawGame();
});
document.addEventListener("keydown", (event)=>{
    const keyMap = {
        ArrowUp: ()=>$09e991522ca7e64e$var$game.moveUp(),
        ArrowDown: ()=>$09e991522ca7e64e$var$game.moveDown(),
        ArrowLeft: ()=>$09e991522ca7e64e$var$game.moveLeft(),
        ArrowRight: ()=>$09e991522ca7e64e$var$game.moveRight()
    };
    if (!keyMap[event.key] || $09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    event.preventDefault();
    if (keyMap[event.key]()) {
        $09e991522ca7e64e$var$drawGame();
        $09e991522ca7e64e$var$updateButtonToRestart();
        $09e991522ca7e64e$var$showStatusMessage($09e991522ca7e64e$var$game.getStatus());
    }
});
$09e991522ca7e64e$var$elements.gameBoard.addEventListener("touchstart", (event)=>{
    $09e991522ca7e64e$var$touchStart.x = event.touches[0].screenX;
    $09e991522ca7e64e$var$touchStart.y = event.touches[0].screenY;
}, {
    passive: true
});
$09e991522ca7e64e$var$elements.gameBoard.addEventListener("touchend", (event)=>{
    const dx = event.changedTouches[0].screenX - $09e991522ca7e64e$var$touchStart.x;
    const dy = event.changedTouches[0].screenY - $09e991522ca7e64e$var$touchStart.y;
    const threshold = 30;
    if (Math.abs(dx) <= threshold && Math.abs(dy) <= threshold) return;
    if (Math.abs(dx) > Math.abs(dy)) dx > 0 ? $09e991522ca7e64e$var$game.moveRight() : $09e991522ca7e64e$var$game.moveLeft();
    else dy > 0 ? $09e991522ca7e64e$var$game.moveDown() : $09e991522ca7e64e$var$game.moveUp();
    $09e991522ca7e64e$var$drawGame();
    $09e991522ca7e64e$var$showStatusMessage($09e991522ca7e64e$var$game.getStatus());
}, {
    passive: true
});
function $09e991522ca7e64e$var$init() {
    const status = $09e991522ca7e64e$var$game.getStatus();
    if (status === "idle") return;
    $09e991522ca7e64e$var$elements.messages.forEach((m)=>m.classList.add($09e991522ca7e64e$var$CLASSES.HIDDEN));
    $09e991522ca7e64e$var$updateButtonToRestart();
    $09e991522ca7e64e$var$drawGame();
    $09e991522ca7e64e$var$showStatusMessage(status);
}
$09e991522ca7e64e$var$init();


//# sourceMappingURL=index.47abe0e1.js.map
